import i18n from '@/helper/i18n';

export default function formatReadStatus(value) {
  return i18n.te(`masterData.creditorVouchers.readStatusOptions.${value}`)
    ? i18n.t(`masterData.creditorVouchers.readStatusOptions.${value}`)
    : value;
}
